// AUTO-GENERATED: 2025-10-28T19:10:34.720157Z
// 🌶️ Thai recipes

export const thaiRecipes = [
{
    name: "Pad Thai",
    cuisine: "Thai",
    ingredients: ["rice noodles", "shrimp", "eggs", "tofu", "bean sprouts", "peanuts", "scallions"],
    sauces: ["tamarind paste", "fish sauce", "sugar", "lime juice", "chili flakes"],
    instructions: "Soak rice noodles in warm water until soft. Mix sauce: tamarind, fish sauce, sugar. Heat wok on high, scramble eggs, remove. Stir-fry shrimp and tofu. Add drained noodles and sauce. Toss constantly 2-3 minutes. Add bean sprouts and scallions. Toss briefly. Serve topped with crushed peanuts, lime wedges, and chili flakes.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Tom Yum Soup",
    cuisine: "Thai",
    ingredients: ["shrimp", "mushrooms", "tomatoes", "lemongrass", "kaffir lime leaves", "galangal"],
    sauces: ["fish sauce", "lime juice", "chili paste", "sugar"],
    instructions: "Bring water to boil with lemongrass, galangal, and kaffir lime leaves. Simmer 10 minutes. Add mushrooms and tom yum paste. Add shrimp and tomatoes. Cook until shrimp turn pink, 3-4 minutes. Season with fish sauce, lime juice, and sugar to balance hot-sour-salty-sweet. Garnish with cilantro and Thai chilies. Serve hot.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Green Curry",
    cuisine: "Thai",
    ingredients: ["chicken breast", "eggplant", "bamboo shoots", "bell peppers", "thai basil"],
    sauces: ["green curry paste", "coconut milk", "fish sauce", "palm sugar"],
    instructions: "Simmer green curry paste in thick coconut cream until fragrant. Add chicken, cook 5 minutes. Add remaining coconut milk, bring to simmer. Add eggplant, bamboo shoots, bell peppers. Simmer until vegetables are tender. Season with fish sauce and palm sugar. Add Thai basil just before serving. Serve with jasmine rice.",
    time: "30 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Pad See Ew",
    cuisine: "Thai",
    ingredients: ["wide rice noodles", "chicken", "chinese broccoli", "eggs"],
    sauces: ["soy sauce", "oyster sauce", "dark soy sauce", "sugar"],
    instructions: "Soak noodles in warm water until soft. Heat wok to very high heat. Stir-fry chicken until cooked. Push aside, scramble eggs. Add noodles, soy sauces, oyster sauce, sugar. Toss quickly. Add Chinese broccoli. Stir-fry 2 minutes until slightly charred (wok hei). Serve immediately.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Massaman Curry",
    cuisine: "Thai",
    ingredients: ["beef", "potatoes", "onions", "peanuts"],
    sauces: ["massaman curry paste", "coconut milk", "fish sauce", "palm sugar", "tamarind paste"],
    instructions: "Brown beef chunks. Fry massaman paste in coconut cream until fragrant. Add beef, stir to coat. Add coconut milk, bring to simmer. Add potatoes, onions, peanuts. Simmer 45-60 minutes until beef is tender. Season with fish sauce, palm sugar, tamarind. Serve with jasmine rice and cucumber relish.",
    time: "90 min",
    difficulty: "Medium",
    points: 100,
    servings: 2
  },
{
    name: "Som Tam",
    cuisine: "Thai",
    ingredients: ["green papaya", "tomatoes", "long beans", "peanuts", "garlic", "thai chilies"],
    sauces: ["fish sauce", "lime juice", "palm sugar", "tamarind juice"],
    instructions: "Pound garlic and chilies in mortar. Add palm sugar, pound to dissolve. Add tomatoes, pound lightly. Add shredded green papaya and long beans. Pound gently to bruise. Add fish sauce, lime juice, tamarind juice. Toss well. Add peanuts, toss briefly. Adjust seasoning to balance spicy-sour-salty-sweet. Serve immediately.",
    time: "15 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Larb",
    cuisine: "Thai",
    ingredients: ["ground pork", "mint", "cilantro", "scallions", "shallots", "toasted rice powder"],
    sauces: ["fish sauce", "lime juice", "chili flakes"],
    instructions: "Cook ground pork in dry pan, breaking up clumps. Drain excess fat. Let cool slightly. Mix with lime juice, fish sauce, toasted rice powder, chili flakes. Add mint, cilantro, scallions, and sliced shallots. Toss well. Taste and adjust seasoning. Serve at room temperature with sticky rice and fresh vegetables.",
    time: "15 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Panang Curry",
    cuisine: "Thai",
    ingredients: ["beef", "bell peppers", "thai basil", "kaffir lime leaves"],
    sauces: ["panang curry paste", "coconut milk", "fish sauce", "palm sugar", "peanut butter"],
    instructions: "Fry panang paste in coconut cream until fragrant and oil separates. Add beef, stir to coat. Add remaining coconut milk and peanut butter. Simmer until beef is tender. Add bell peppers and kaffir lime leaves. Season with fish sauce and palm sugar. Simmer 5 more minutes. Garnish with Thai basil. Serve with rice.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Thai Basil Chicken",
    cuisine: "Thai",
    ingredients: ["chicken breast", "thai basil", "bell peppers", "onion", "garlic", "thai chilies"],
    sauces: ["oyster sauce", "soy sauce", "fish sauce", "sugar"],
    instructions: "Heat wok to very high heat. Stir-fry garlic and chilies 30 seconds. Add chicken, stir-fry until nearly cooked. Add bell peppers and onions. Stir-fry 2 minutes. Add oyster sauce, soy sauce, fish sauce, sugar. Mix well. Add Thai basil, stir just until wilted. Serve immediately over rice with fried egg on top.",
    time: "15 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Tom Kha Gai",
    cuisine: "Thai",
    ingredients: ["chicken breast", "mushrooms", "galangal", "lemongrass", "kaffir lime leaves"],
    sauces: ["coconut milk", "fish sauce", "lime juice", "chili paste", "palm sugar"],
    instructions: "Simmer coconut milk with galangal, lemongrass, kaffir lime leaves. Add chicken and mushrooms. Cook until chicken is done, 7-8 minutes. Add fish sauce, lime juice, palm sugar, and chili paste. Balance flavors: sweet-sour-salty-spicy. Add coconut cream for richness. Garnish with cilantro. Serve hot with jasmine rice.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
